<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%">
      <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">แดชบอร์ดรายงานการสั่งซื้อ</v-card-title>
      <v-card-title class="px-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> แดชบอร์ดรายงานการสั่งซื้อ
      </v-card-title>
      <v-card-text>
<!-- filter desktop, ipad ----------------------------------------------------------------------------------------------------------->
        <v-row no-gutters>
<!-- desktop filter chart ------------------------------------------------------------------------------------------------------>
          <v-col cols="12" v-if="!IpadProSize && !IpadSize && !MobileSize">
            <v-row>
              <v-col cols="12">
                <span>ข้อมูลลูกค้า
                  <v-autocomplete
                    class="pl-1 d-inline-block" style="width: 220px;" v-model="selectCusId" :items="cusIdListMenu" :menu-props="{ maxWidth: IpadProSize || IpadSize ? '250px' : MobileSize ? '319px' : '250px' }"
                    outlined dense item-text="cus_data" placeholder="เลือกข้อมูลลูกค้า" no-data-text="ไม่พบเลือกข้อมูลลูกค้าที่ค้นหา" return-object hide-details @change="onChange"
                ></v-autocomplete>
                </span>
                <span class="pl-3 pt-3 d-inline-block" v-if="dataSelect !== 'รายเดือน' && dataSelect !== 'ราย 3 เดือน' && dataSelect !== 'ราย 6 เดือน' && dataSelect !== 'รายปี'">วันที่เริ่ม-สิ้นสุด
                  <v-menu
                    class="pl-1 d-inline-block"
                    ref="dialog"
                    v-model="modal"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="d-inline-block"
                        style="max-width: 9vw"
                        v-model="dateStart"
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        outlined
                        dense
                        placeholder="DD/MM/YYYY"
                        hide-details
                        :disabled="dataSelect === 'ทั้งหมด'"
                      ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                    </template>
                    <v-date-picker
                      color="#27AB9C"
                      ref="pickerDateStart"
                      v-model="dateFormatted"
                      :active-picker.sync="activePicker"
                      scrollable
                      reactive
                      no-title
                      :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                      @input="modal = false"
                      @click:date="getSelectStartDate(dateFormatted)"
                    >
                    </v-date-picker>
                  </v-menu>
                </span>
                <sapn class="px-2 d-inline-block pt-3" v-if="dataSelect !== 'รายเดือน' && dataSelect !== 'ราย 3 เดือน' && dataSelect !== 'ราย 6 เดือน' && dataSelect !== 'รายปี'">-</sapn>
                <span class="d-inline-block pt-3" v-if="dataSelect !== 'รายเดือน' && dataSelect !== 'ราย 3 เดือน' && dataSelect !== 'ราย 6 เดือน' && dataSelect !== 'รายปี'">
                  <v-menu
                    class="d-inline-block"
                    ref="dialog1"
                    v-model="modal1"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    left
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="d-inline-block"
                        style="max-width: 9vw"
                        v-model="dateEnd"
                        v-bind="attrs"
                        v-on="on"
                        dense
                        placeholder="DD/MM/YYYY"
                        outlined
                        readonly
                        hide-details
                        :disabled="dataSelect === 'รายวัน' || dataSelect === 'ทั้งหมด' ? true : false"
                      ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                    </template>
                    <v-date-picker
                      color="#27AB9C"
                      v-model="dateFormatted2"
                      ref="pickerDateEnd"
                      :active-picker.sync="activePicker"
                      scrollable
                      no-title
                      :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                      :min="dateFormatted"
                      @input="modal1 = false"
                      @click:date="getSelectDateEnd(dateFormatted2)"
                    >
                    </v-date-picker>
                  </v-menu>
                </span>
                <span class="pl-3 pt-3 d-inline-block" v-if="dataSelect === 'รายเดือน'">เดือน
                  <v-menu
                    class="pl-1 d-inline-block"
                    ref="dialogMonth"
                    v-model="modalMonth"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="d-inline-block"
                        style="max-width: 9vw"
                        v-model="month"
                        v-bind="attrs"
                        v-on="on"
                        dense
                        placeholder="MMMM"
                        outlined
                        readonly
                        hide-details
                      ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                    </template>
                    <v-date-picker
                      color="#27AB9C"
                      ref="pickerMonth"
                      v-model="MonthFormatted"
                      :active-picker.sync="activePicker"
                      scrollable
                      reactive
                      no-title
                      :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                      min="1950-01-01"
                      @click:month="SaveMonth(MonthFormatted)"
                    >
                    </v-date-picker>
                  </v-menu>
                </span>
                <span class="pl-3 pt-3 d-inline-block" v-if="dataSelect === 'ราย 3 เดือน' || dataSelect === 'ราย 6 เดือน'">เดือนเริ่มต้น-สิ้นสุด
                  <v-menu
                    class="pl-1 d-inline-block"
                    ref="dialogStartMonth"
                    v-model="modalStartMonth"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="d-inline-block"
                        style="max-width: 8vw"
                        v-model="startMonth"
                        v-bind="attrs"
                        v-on="on"
                        dense
                        placeholder="MMMM"
                        outlined
                        readonly
                        hide-details
                      ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                    </template>
                    <v-date-picker
                      color="#27AB9C"
                      ref="pickerStartMonth"
                      v-model="StartMonthFormatted"
                      :active-picker.sync="activePicker"
                      scrollable
                      reactive
                      no-title
                      :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                      min="1950-01-01"
                      @input="modalStartMonth = false"
                      @change="SaveStartMonth(StartMonthFormatted)"
                      @click:month="SaveStartMonth(StartMonthFormatted)"
                    >
                    </v-date-picker>
                  </v-menu>
                </span>
                <span class="px-2 d-inline-block pt-3" v-if="dataSelect === 'ราย 3 เดือน' || dataSelect === 'ราย 6 เดือน'">-</span>
                <v-text-field v-if="dataSelect === 'ราย 3 เดือน'" class="d-inline-block" v-model="endMonth"  dense placeholder="MMMM" outlined readonly hide-details style="max-width: 8vw">
                  <v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon>
                </v-text-field>
                <v-text-field v-if="dataSelect === 'ราย 6 เดือน'" class="d-inline-block" v-model="endSixMonth"  dense placeholder="MMMM" outlined readonly hide-details style="max-width: 8vw">
                  <v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon>
                </v-text-field>
                <span class="pl-3 pt-3 d-inline-block" v-if="dataSelect === 'รายปี'">ปี
                  <v-menu
                    class="pl-1 d-inline-block"
                    ref="dialogYear"
                    v-model="modalYear"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="d-inline-block"
                        style="max-width: 9vw"
                        v-model="year"
                        v-bind="attrs"
                        v-on="on"
                        dense
                        placeholder="YYYY"
                        outlined
                        readonly
                        hide-details
                      ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                    </template>
                    <v-date-picker
                      color="#27AB9C"
                      ref="pickerYear"
                      v-model="YearFormatted"
                      :active-picker.sync="activePicker"
                      scrollable
                      reactive
                      no-title
                      :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                      min="1950-01-01"
                      @click:year="SaveYear(YearFormatted)"
                    >
                    </v-date-picker>
                  </v-menu>
                </span>
                <span class="pl-3">แสดงผล <v-select class="pl-1 d-inline-block" style="width: 10vw" v-model="selectStatus" @change="getFilterType()" :items="statusListMenu" return-object item-text="text" outlined dense placeholder="เลือกการแสดงผล" hide-details></v-select></span>
              </v-col>
            </v-row>
          </v-col>
<!-- Filter ipad, ipadpro ------------------------------------------------------------------------------------------------------------->
          <v-col cols="12" v-else-if="IpadSize || IpadProSize">
            <v-row>
              <v-col cols="12" class="d-flex flex-row">
                <span class="pl-0 pr-3 d-inline-block pt-3">ข้อมูลลูกค้า</span>
                <v-autocomplete
                  v-model="selectCusId"
                  :items="cusIdListMenu"
                  outlined dense
                  item-text="cus_data"
                  placeholder="เลือกข้อมูลลูกค้า"
                  no-data-text="ไม่พบเลือกข้อมูลลูกค้าที่ค้นหา"
                  return-object
                  hide-details
                  @change="onChange"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" class="d-flex flex-row" v-if="dataSelect === 'ราย 3 เดือน' || dataSelect === 'ราย 6 เดือน'">
                <span class="pl-0 pr-3 d-inline-block pt-3">เดือนเริ่มต้น-สิ้นสุด</span>
                <v-menu v-if="dataSelect === 'ราย 3 เดือน' || dataSelect === 'ราย 6 เดือน'"
                  ref="dialogStartMonth"
                  v-model="modalStartMonth"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      style="width: 9vw;"
                      v-model="startMonth"
                      v-bind="attrs"
                      v-on="on"
                      readonly
                      outlined
                      dense
                      placeholder="MMMM"
                      hide-details
                    ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                  </template>
                  <v-date-picker
                    ref="pickerStartMonth"
                    v-model="StartMonthFormatted"
                    :active-picker.sync="activePicker"
                    type="month"
                    scrollable
                    no-title
                    reactive
                    color="#27AB9C"
                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                    min="1950-01-01"
                    @input="modalStartMonth = false"
                    @click:month="SaveStartMonth(StartMonthFormatted)">
                  </v-date-picker>
                </v-menu>
                <span class="px-3 d-inline-block pt-3" v-if="dataSelect === 'ราย 3 เดือน' || dataSelect === 'ราย 6 เดือน'">- </span>
                <v-text-field v-if="dataSelect === 'ราย 3 เดือน'" v-model="endMonth"  dense placeholder="MMMM" outlined readonly hide-details style="width: 9vw">
                  <v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon>
                </v-text-field>
                <v-text-field v-if="dataSelect === 'ราย 6 เดือน'" v-model="endSixMonth"  dense placeholder="MMMM" outlined readonly hide-details style="width: 9vw">
                  <v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon>
                </v-text-field>
              </v-col>
              <v-col cols="12" class="d-flex flex-row" v-else-if="dataSelect === 'รายเดือน'">
                <span class="pl-0 pr-3 d-inline-block pt-3">{{ dataSelect === 'รายเดือน' ? 'เดือน' : 'ปี' }}</span>
                <v-menu v-if="dataSelect === 'รายเดือน'"
                  ref="dialogMonth"
                  v-model="modalMonth"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="month"
                      v-bind="attrs"
                      v-on="on"
                      readonly
                      outlined
                      dense
                      placeholder="MMMM"
                      hide-details
                    ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                  </template>
                  <!-- end date -->
                  <v-date-picker
                    color="#27AB9C"
                    ref="pickerMonth"
                    v-model="MonthFormatted"
                    :active-picker.sync="activePicker"
                    scrollable
                    reactive
                    no-title
                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                    min="1950-01-01"
                    @click:month="SaveMonth(MonthFormatted)"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" class="d-flex flex-row" v-else-if="dataSelect === 'รายปี'">
                <span class="pl-0 pr-3 d-inline-block pt-3">{{ dataSelect === 'รายเดือน' ? 'เดือน' : 'ปี' }}</span>
                <v-menu v-if="dataSelect === 'รายปี'"
                  ref="dialogYear"
                  v-model="modalYear"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                    v-model="year"
                      v-bind="attrs"
                      v-on="on"
                      readonly
                      outlined
                      dense
                      placeholder="YYYY"
                      hide-details
                    ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                  </template>
                  <v-date-picker
                    color="#27AB9C"
                    ref="pickerYear"
                    v-model="YearFormatted"
                    :active-picker.sync="activePicker"
                    scrollable
                    reactive
                    no-title
                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                    min="1950-01-01"
                    @click:year="SaveYear(YearFormatted)"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" class="d-flex flex-row" v-else>
                <span class="pl-0 pr-3 d-inline-block pt-3">วันที่เริ่ม-สิ้นสุด </span>
                <!-- start date -->
                <v-menu
                  ref="dialog"
                  v-model="modal"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      style="width: 100px;"
                      v-model="dateStart"
                      v-bind="attrs"
                      v-on="on"
                      readonly
                      outlined
                      dense
                      placeholder="DD/MM/YYYY"
                      hide-details
                      :disabled="dataSelect === 'ทั้งหมด'"
                    ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                  </template>
                  <!-- end date -->
                  <v-date-picker
                    color="#27AB9C"
                    ref="pickerDateStart"
                    v-model="dateFormatted"
                    :active-picker.sync="activePicker"
                    scrollable
                    reactive
                    no-title
                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                    @input="modal = false"
                    @click:date="getSelectStartDate(dateFormatted)"
                  >
                  </v-date-picker>
                </v-menu>
                <span class="px-3 d-inline-block pt-3" v-if="dataSelect !== 'รายเดือน' && dataSelect !== 'ราย 3 เดือน' && dataSelect !== 'ราย 6 เดือน' && dataSelect !== 'รายปี'">- </span>
                <!-- end date -->
                <v-menu v-if="dataSelect !== 'รายเดือน' && dataSelect !== 'ราย 3 เดือน' && dataSelect !== 'ราย 6 เดือน' && dataSelect !== 'รายปี'"
                  ref="dialog1"
                  v-model="modal1"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  left
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateEnd"
                      v-bind="attrs"
                      v-on="on"
                      dense
                      placeholder="DD/MM/YYYY"
                      outlined
                      readonly
                      hide-details
                      style="width: 100px;"
                      :disabled="dataSelect === 'รายวัน' || dataSelect === 'ทั้งหมด' ? true : false"
                    ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                  </template>
                  <v-date-picker
                    color="#27AB9C"
                    v-model="dateFormatted2" ref="pickerDateEnd" :active-picker.sync="activePicker" scrollable no-title :readonly="dataSelect === 'รายวัน' ? true : false"
                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                    :min="dateFormatted"
                    @input="modal1 = false"
                    @click:date="getSelectDateEnd(dateFormatted2)"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" class="d-flex flex-row">
                <span class="pl-0 pr-3 d-inline-block pt-3">แสดงผล</span>
                <v-select v-model="selectStatus" @change="getFilterType()" :items="statusListMenu" return-object item-text="text" outlined dense placeholder="เลือกการแสดงผล" hide-details></v-select>
              </v-col>
            </v-row>
          </v-col>
<!-- Filter Mobile datepicker แบบ dialog แทน------------------------------------------------------------------------------------------------------------->
          <v-col cols="12" v-else>
            <v-row>
              <v-col cols="12" class="d-flex flex-row">
                <span class="pl-0 pr-3 d-inline-block pt-3">ข้อมูลลูกค้า</span>
                <v-autocomplete
                  v-model="selectCusId"
                  :items="cusIdListMenu"
                  outlined dense
                  item-text="cus_data"
                  placeholder="เลือกข้อมูลลูกค้า"
                  no-data-text="ไม่พบเลือกข้อมูลลูกค้าที่ค้นหา"
                  return-object
                  hide-details
                  @change="onChange"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" class="d-flex flex-row" v-if="dataSelect === 'ราย 3 เดือน' || dataSelect === 'ราย 6 เดือน'">
                <span class="pl-0 pr-3 d-inline-block pt-3">เดือนเริ่มต้น-สิ้นสุด</span>
                <v-dialog v-if="dataSelect === 'ราย 3 เดือน' || dataSelect === 'ราย 6 เดือน'"
                  ref="dialogStartMonth"
                  v-model="modalStartMonth"
                  :return-value.sync="date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      style="width: 9vw;"
                      v-model="startMonth"
                      v-bind="attrs"
                      v-on="on"
                      readonly
                      outlined
                      dense
                      placeholder="MMMM"
                      hide-details
                    ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                  </template>
                  <v-date-picker
                    ref="pickerStartMonth"
                    v-model="StartMonthFormatted"
                    :active-picker.sync="activePicker"
                    type="month"
                    scrollable
                    no-title
                    reactive
                    color="#27AB9C"
                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                    min="1950-01-01"
                    @input="modalStartMonth = false"
                    @click:month="SaveStartMonth(StartMonthFormatted)">
                  </v-date-picker>
                </v-dialog>
                <span class="px-3 d-inline-block pt-3" v-if="dataSelect === 'ราย 3 เดือน' || dataSelect === 'ราย 6 เดือน'">- </span>
                <v-text-field v-if="dataSelect === 'ราย 3 เดือน'" v-model="endMonth"  dense placeholder="MMMM" outlined readonly hide-details style="width: 9vw">
                  <v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon>
                </v-text-field>
                <v-text-field v-if="dataSelect === 'ราย 6 เดือน'" v-model="endSixMonth"  dense placeholder="MMMM" outlined readonly hide-details style="width: 9vw">
                  <v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon>
                </v-text-field>
              </v-col>
              <v-col cols="12" class="d-flex flex-row" v-else-if="dataSelect === 'รายเดือน'">
                <span class="pl-0 pr-3 d-inline-block pt-3">{{ dataSelect === 'รายเดือน' ? 'เดือน' : 'ปี' }}</span>
                <v-dialog v-if="dataSelect === 'รายเดือน'"
                  ref="dialogMonth"
                  v-model="modalMonth"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="month"
                      v-bind="attrs"
                      v-on="on"
                      readonly
                      outlined
                      dense
                      placeholder="MMMM"
                      hide-details
                    ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                  </template>
                  <!-- end date -->
                  <v-date-picker
                    color="#27AB9C"
                    ref="pickerMonth"
                    v-model="MonthFormatted"
                    :active-picker.sync="activePicker"
                    scrollable
                    reactive
                    no-title
                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                    min="1950-01-01"
                    @click:month="SaveMonth(MonthFormatted)"
                  >
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" class="d-flex flex-row" v-else-if="dataSelect === 'รายปี'">
                <span class="pl-0 pr-3 d-inline-block pt-3">{{ dataSelect === 'รายเดือน' ? 'เดือน' : 'ปี' }}</span>
                <v-dialog v-if="dataSelect === 'รายปี'"
                  ref="dialogYear"
                  v-model="modalYear"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                    v-model="year"
                      v-bind="attrs"
                      v-on="on"
                      readonly
                      outlined
                      dense
                      placeholder="YYYY"
                      hide-details
                    ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                  </template>
                  <v-date-picker
                    color="#27AB9C"
                    ref="pickerYear"
                    v-model="YearFormatted"
                    :active-picker.sync="activePicker"
                    scrollable
                    reactive
                    no-title
                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                    min="1950-01-01"
                    @click:year="SaveYear(YearFormatted)"
                  >
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" class="d-flex flex-row" v-else>
                <span class="pl-0 pr-3 d-inline-block pt-3">วันที่เริ่ม-สิ้นสุด </span>
                <!-- start date -->
                <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      style="width: 100px;"
                      v-model="dateStart"
                      v-bind="attrs"
                      v-on="on"
                      readonly
                      outlined
                      dense
                      placeholder="DD/MM/YYYY"
                      hide-details
                      :disabled="dataSelect === 'ทั้งหมด'"
                    ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                  </template>
                  <!-- end date -->
                  <v-date-picker
                    color="#27AB9C"
                    ref="pickerDateStart"
                    v-model="dateFormatted"
                    :active-picker.sync="activePicker"
                    scrollable
                    reactive
                    no-title
                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                    @input="modal = false"
                    @click:date="getSelectStartDate(dateFormatted)"
                  >
                  </v-date-picker>
                </v-dialog>
                <span class="px-3 d-inline-block pt-3" v-if="dataSelect !== 'รายเดือน' && dataSelect !== 'ราย 3 เดือน' && dataSelect !== 'ราย 6 เดือน' && dataSelect !== 'รายปี'">- </span>
                <!-- end date -->
                <v-dialog v-if="dataSelect !== 'รายเดือน' && dataSelect !== 'ราย 3 เดือน' && dataSelect !== 'ราย 6 เดือน' && dataSelect !== 'รายปี'"
                ref="dialog1"
                  v-model="modal1"
                  :return-value.sync="date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateEnd"
                      v-bind="attrs"
                      v-on="on"
                      dense
                      placeholder="DD/MM/YYYY"
                      outlined
                      readonly
                      hide-details
                      style="width: 100px;"
                      :disabled="dataSelect === 'รายวัน' || dataSelect === 'ทั้งหมด' ? true : false"
                    ><v-icon slot="append" color="#27AB9C">mdi-calendar </v-icon></v-text-field>
                  </template>
                  <v-date-picker
                    color="#27AB9C"
                    v-model="dateFormatted2" ref="pickerDateEnd" :active-picker.sync="activePicker" scrollable no-title :readonly="dataSelect === 'รายวัน' ? true : false"
                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                    :min="dateFormatted"
                    @input="modal1 = false"
                    @click:date="getSelectDateEnd(dateFormatted2)"
                  >
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" class="d-flex flex-row">
                <span class="pl-0 pr-3 d-inline-block pt-3">แสดงผล</span>
                <v-select v-model="selectStatus" @change="getFilterType()" :items="statusListMenu" return-object item-text="text" style="width: 10vw" outlined dense placeholder="เลือกการแสดงผล" hide-details></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
<!-- information ---------------------------------------------------------------------------------------------------------------------------->
        <v-row align="center" justify="center" style="margin-bottom: 45px;">
          <v-col cols="12" md="6" sm="6">
            <v-card color="#EAFBF9" :elevation="0" min-height="102" class="d-flex align-center justify-center">
              <v-row>
                <v-col align="center" justify="center" :class="MobileSize ? 'information-text-mobile' : IpadSize || IpadProSize ? 'information-text-ipad': 'information-text'">
                  <span :class="MobileSize ? 'information-text-mobile' : IpadSize || IpadProSize ? 'information-text-ipad': 'information-text'">
                    จำนวนรายการสั่งซื้อทั้งหมด <span :class="MobileSize ? 'order-text-mobile' : IpadSize || IpadProSize ? 'order-text-ipad' : 'order-text'">{{ Number(totalOrders).toLocaleString(undefined, { minimumFractionDigits: 0 }) }}</span> รายการ
                  </span>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <v-card color="#F0F5FB" :elevation="0" min-height="102" class="d-flex align-center justify-center">
              <v-row>
                <v-col align="center" justify="center" :class="MobileSize ? 'information-text-mobile' : IpadSize || IpadProSize ? 'information-text-ipad': 'information-text'">
                  <span :class="MobileSize ? 'information-text-mobile' : IpadSize || IpadProSize ? 'information-text-ipad': 'information-text'">
                    ยอดขายทั้งหมด <span :class="MobileSize ? 'sales-text-mobile' : IpadSize || IpadProSize ? 'sales-text-ipad': 'sales-text'">{{ Number(totalPrice).toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</span> บาท
                  </span>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
<!-- chart ---------------------------------------------------------------------------------------------------------------------------------->
        <v-row dense style="z-index: -1;">
          <v-card outlined elevation="0" width="100%" height="100%" style="background: #FFFFFF; border: 1px solid #EBEBEB; box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25); border-radius: 6px;">
            <v-card-text>
              <div id='chart' class="mt-5">
                <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
              </div>
            </v-card-text>
          </v-card>
        </v-row>
<!-- Ranking -------------------------------------------------------------------------------------------------------------------------------->
        <v-row class="mt-4">
          <v-col cols="12" md="6">
            <ProductRanking :listItem="itemProduct"/>
          </v-col>
          <v-col cols="12" md="6" v-if="selectCusId.cus_code === 'ทั้งหมด'">
            <CustomerRanking :listItem="itemCustomer"/>
          </v-col>
          <v-col cols="12" md="6">
            <PromotionRanking :listItem="itemPromotion"/>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { Decode } from '@/services'
export default {
  name: 'ApexChart',
  components: {
    ProductRanking: () => import('@/components/Gracz/Card/TopTenProductCard'),
    CustomerRanking: () => import('@/components/Gracz/Card/TopTenCustomerCard'),
    PromotionRanking: () => import('@/components/Gracz/Card/TopTenPromotionCard')
  },
  data () {
    return {
      userDetailSelling: '',
      customerData: '',
      salesIdListMenu: [],
      selectSalesId: '',
      cusIdListMenu: [],
      selectCusId: '',
      statusListMenu: [
        { text: 'ไม่ระบุ', status: 'none' },
        { text: 'รายวัน', status: 'day' },
        { text: 'รายเดือน', status: 'month' },
        { text: 'ราย 3 เดือน', status: '3month' },
        { text: 'ราย 6 เดือน', status: '6month' },
        { text: 'รายปี', status: 'year' },
        { text: 'ทั้งหมด', status: 'all' }
      ],
      selectStatus: { text: 'ไม่ระบุ', status: 'none' },
      modal: false,
      modal1: false,
      date: '',
      dateStart: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dateEnd: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      startDate: this.dateFormat((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10), 'yyyy-MM-dd'),
      endDate: this.dateFormat((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10), 'yyyy-MM-dd'),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateFormatted2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      activePicker: null,
      dataSelect: '',
      modalMonth: false,
      modalYear: false,
      modalStartMonth: false,
      modalEndMonth: false,
      startMonth: '',
      endMonth: '',
      endSixMonth: '',
      month: '',
      year: '',
      StartMonthFormatted: null,
      EndMonthFormatted: null,
      MonthFormatted: null,
      YearFormatted: null,
      itemProduct: [],
      itemCustomer: [],
      itemSales: [],
      itemPromotion: [],
      dataRes: [],
      series: [],
      dateGraph: [],
      totalPrice: '',
      totalOrders: ''
    }
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push('/Order/SalesDashbordMobile').catch(() => {})
      } else {
        this.$router.push('/Order/SalesDashbord').catch(() => {})
      }
    },
    modalYear (val) {
      // console.log(val)
      val && this.$nextTick(() => (this.activePicker = 'YEAR'))
    },
    modalMonth (val) {
      val && this.$nextTick(() => (this.activePicker = 'MONTH'))
    },
    modalStartMonth (val) {
      val && this.$nextTick(() => (this.activePicker = 'MONTH'))
    },
    modal (val) {
      val && this.$nextTick(() => (this.activePicker = 'DATE'))
    },
    modal1 (val) {
      val && this.$nextTick(() => (this.activePicker = 'DATE'))
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    },
    chartOptions () {
      return {
        chart: {
          height: 350,
          type: 'line',
          fontFamily: 'Sukhumvit Set',
          stacked: false,
          toolbar: {
            show: true,
            offsetX: 0,
            offsetY: -15,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true | '<img src="/static/icons/reset.png" width="20">',
              customIcons: []
            }
          }
        },
        colors: ['#2CD9C5', '#6497D5'],
        plotOptions: {
          bar: {
            columnWidth: '90%',
            horizontal: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: [1, 1]
        },
        xaxis: {
          categories: this.dateGraph,
          labels: {
            rotate: -58
          }
        },
        grid: {
          padding: {
            right: 17
          }
        },
        yaxis: [
          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#2CD9C5'
            },
            labels: {
              style: {
                colors: '#2CD9C5'
              },
              formatter: (value) => {
                return Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              }
            },
            title: {
              // text: 'Income (thousand crores)',
              style: {
                color: '#2CD9C5'
              }
            },
            tooltip: {
              enabled: false
            }
          },
          {
            seriesName: 'ยอดขาย',
            opposite: true,
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: '#6497D5'
            },
            labels: {
              style: {
                colors: '#6497D5'
              },
              formatter: (value) => {
                return Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              }
            },
            title: {
              // text: 'Operating Cashflow (thousand crores)',
              style: {
                color: '#6497D5'
              }
            },
            tooltip: {
              enabled: false
            }
          }
        ],
        tooltip: {
          fixed: {
            enabled: true,
            position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
            offsetY: -90,
            offsetX: 50
          }
        },
        legend: {
          horizontalAlign: 'center'
          // offsetX: 40
        }
      }
    }
  },
  created () {
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
      }
      if (localStorage.getItem('OnlinePurchase') !== null) {
        this.customerData = JSON.parse(Decode.decode(localStorage.getItem('OnlinePurchase')))
      }
      this.getData()
      this.getDataTopTen()
      this.getCustomerList()
    }
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/UserProfileMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/UserProfile' }).catch(() => {})
      }
    },
    async getData () {
      // this.dataRes = []
      this.series = []
      this.dateGraph = []
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        role_user: shopData.position,
        emp_code: shopData.emp_code,
        cus_id: this.selectCusId ? this.selectCusId.cus_id : '',
        start_date: this.dataSelect === 'ทั้งหมด' ? '' : this.dateFormatted,
        end_date: this.dataSelect === 'ทั้งหมด' ? '' : this.dateFormatted2,
        type: this.selectStatus.status
      }
      await this.$store.dispatch('actionsGraczDashbordSales', data)
      var response = await this.$store.state.ModuleGraczDashbord.stateGraczDashbordSales
      if (response.message === 'Get dashboard successful.') {
        // this.dateGraph = response.date_graph
        // this.dataRes = response.data.transection
        var seriesCountOrder = await response.data.data_count_orders_graph
        var seriesNetPrice = await response.data.data_net_price_graph
        var dataDateGraph = await response.data.date_graph
        this.series = [
          {
            name: 'จำนวนการสั่งซื้อ',
            type: 'column',
            data: seriesCountOrder
          }, {
            name: 'ยอดขาย',
            type: 'column',
            data: seriesNetPrice
          }
        ]
        // this.series = seriesNetPrice
        for (var i = 0; i < dataDateGraph.length; i++) {
          if (this.dataSelect === 'ราย 3 เดือน' || this.dataSelect === 'ราย 6 เดือน' || this.dataSelect === 'รายปี' || this.dataSelect === 'ทั้งหมด') {
            this.dateGraph.push(new Date(dataDateGraph[i]).toLocaleDateString('th-TH', { year: 'numeric', month: 'long' }))
          } else {
            this.dateGraph.push(new Date(dataDateGraph[i]).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' }))
          }
        }
        this.totalOrders = response.data.total_orders
        this.totalPrice = response.data.total_price
      } else {
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    async getDataTopTen () {
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        role_user: shopData.position,
        emp_code: shopData.emp_code,
        cus_id: this.selectCusId ? this.selectCusId.cus_id : '',
        start_date: this.dateFormatted,
        end_date: this.dateFormatted2,
        type: this.selectStatus.status
      }
      await this.$store.dispatch('actionsGraczDashbordTopTenSales', data)
      var response = await this.$store.state.ModuleGraczDashbord.stateGraczDashbordTopTenSales
      if (response.message === 'Get dashboard top 10 successful.') {
        this.itemCustomer = response.data.customers
        this.itemProduct = response.data.products
        this.itemSales = response.data.sales
        this.itemPromotion = response.data.promotions
      } else {
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'This type need parameter start_date and end_date') {
          this.itemCustomer = null
          this.itemProduct = null
          this.itemSales = null
          this.itemPromotion = null
          this.totalOrders = 0
          this.totalPrice = 0
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    async getCustomerList () {
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id
      }
      await this.$store.dispatch('actionsGraczListCustomerOfSales', data)
      var response = await this.$store.state.ModuleGraczCustomer.stateGraczListCustomerOfSales
      if (response.message === 'Get list customer of sales success.') {
        var all = { cus_id: '', cus_code: 'ทั้งหมด', cus_data: 'ทั้งหมด' }
        response.data.list_customer.forEach(e => {
          e.cus_data = e.cus_code + ' ' + e.cus_name
        })
        this.cusIdListMenu = response.data.list_customer
        this.cusIdListMenu.unshift(all)
        this.selectCusId = { cus_id: '', cus_code: 'ทั้งหมด', cus_data: 'ทั้งหมด' }
        // console.log('cusIdListMenu', this.cusIdListMenu)
      } else if (response.message === 'This user is unauthorized.') {
        this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      } else if (response.message === 'Not access this function.') {
        this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      } else {
        var [msg, iconMsg] = this.getErrorMsg(response.message)
        this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
      }
    },
    getSelectStartDate (val) {
      if (val !== '') {
        this.$refs.dialog.save(val)
        this.$refs.pickerDateStart.activePicker = 'DATE'
        this.dateStart = ''
        this.dateSelectFunctionOne = ''
        this.clearEndDate()
        this.dateSelectFunctionOne = new Date(this.dateFormatted)
        this.dateStart = this.formatDate(new Date(this.dateSelectFunctionOne.setDate(this.dateSelectFunctionOne.getDate()) - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10))
        // this.dateStart = new Date(this.dateSelectFunctionOne).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' })
        this.modal = false
      }
      if (this.dataSelect === 'รายวัน') {
        this.dateFormatted2 = this.dateFormatted
        this.getData()
        this.getDataTopTen()
      }
    },
    getFilterType () {
      this.dataSelect = this.selectStatus.text
      this.clearDateFilter()
      this.getData()
      this.getDataTopTen()
    },
    clearDateFilter () {
      this.dateStart = ''
      this.dateSelectFunctionOne = ''
      this.dateFormatted1 = ''
      this.dateEnd = ''
      this.dateSelectFunctionTwo = ''
      this.dateFormatted2 = ''
      this.month = ''
      this.yesr = ''
      this.startMonth = ''
      this.endMonth = ''
      this.endSixMonth = ''
    },
    onChange () {
      this.getData()
      this.getDataTopTen()
    },
    clearEndDate () {
      this.dateEnd = ''
      this.dateSelectFunctionTwo = ''
      this.dateFormatted2 = ''
    },
    getSelectDateEnd (val) {
      if (val !== '') {
        this.$refs.dialog1.save(val)
        this.$refs.pickerDateEnd.activePicker = 'DATE'
        this.dateSelectFunctionTwo = ''
        this.dateSelectFunctionTwo = new Date(this.dateFormatted2)
        this.dateEnd = this.formatDate(new Date(this.dateSelectFunctionTwo.setDate(this.dateSelectFunctionTwo.getDate()) - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10))
        // this.dateEnd = new Date(this.dateSelectFunctionTwo).toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' })
        this.modal1 = false
        this.getData()
        this.getDataTopTen()
      }
    },
    dateFormat (inputDate, format) {
      // parse the input date
      const date = new Date(inputDate)
      // extract the parts of the date
      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear()
      // replace the month
      format = format.replace('MM', month.toString().padStart(2, '0'))
      // replace the year
      if (format.indexOf('yyyy') > -1) {
        format = format.replace('yyyy', year.toString())
      } else if (format.indexOf('yy') > -1) {
        format = format.replace('yy', year.toString().substr(2, 2))
      }
      // replace the day
      format = format.replace('dd', day.toString().padStart(2, '0'))
      return format
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatDateToShow (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    },
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return ('กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning')
      } else if (msg === 'Data missing. Please check your parameter and try again.') {
        return ['ข้อมูลขาดหาย', 'warning']
      } else if (msg === 'Not access this function.') {
        return ['มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Employee not found. Please check and try again.') {
        return ['ไม่พบพนักงาน โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Seller shop not found.' || msg === 'Not Found Seller Shop') {
        return ['ไม่พบร้านค้า', 'warning']
      } else if (msg === 'Parameter Missing. Please check and try again.') {
        return ['ข้อมูลขาดหาย โปรดลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Customer in this shop not found.') {
        return ['ไม่พบลูกค้าในร้านนี้', 'warning']
      } else {
        return [msg, 'error']
      }
    },
    SaveMonth (val) {
      if (val !== '') {
        this.$refs.dialogMonth.save(val)
        this.$refs.pickerMonth.activePicker = 'MONTH'
        this.month = new Date(this.MonthFormatted).toISOString().substr(0, 7)
        var SelectMonth = new Date(this.MonthFormatted)
        // แปลงข้อมูลโดยกำหนดวันที่เริ่มต้นของเดือน และวันสุดท้ายของเดือน
        var lastday = new Date(SelectMonth.getFullYear(), (SelectMonth.getMonth()) + 1, 0).getDate()
        this.dateFormatted = this.dateFormat(new Date(new Date(SelectMonth.getFullYear(), SelectMonth.getMonth()) - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10), 'yyyy-MM-dd')
        this.dateFormatted2 = this.dateFormat(new Date(new Date(SelectMonth.getFullYear(), SelectMonth.getMonth() + 1) - lastday), 'yyyy-MM-dd')
        this.modalMonth = false
        this.getData()
        this.getDataTopTen()
      }
    },
    SaveYear (val) {
      console.log('SaveYear')
      this.$refs.dialogYear.save(val)
      this.$refs.pickerYear.activePicker = 'YEAR'
      this.year = new Date(this.YearFormatted).toISOString().substr(0, 4)
      var lastday = new Date(this.year, (1) + 1, 0).getDate()
      // แปลงข้อมูลโดยกำหนดวันที่เริ่มต้นของเดือนต้นปี และวันสุดท้ายของเดือนปลายปี
      this.dateFormatted = this.dateFormat(new Date(new Date(this.year, 0) - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10), 'yyyy-MM-dd')
      this.dateFormatted2 = this.dateFormat(new Date(new Date(this.year, 12) - lastday), 'yyyy-MM-dd')
      this.modalYear = false
      this.getData()
      this.getDataTopTen()
    },
    SaveStartMonth (val) {
      this.$refs.dialogStartMonth.save(val)
      this.$refs.pickerStartMonth.activePicker = 'MONTH'
      this.startMonth = new Date(this.StartMonthFormatted).toISOString().substr(0, 7)
      var SelectMonth = new Date(this.StartMonthFormatted)
      var lastday
      if (this.dataSelect === 'ราย 3 เดือน') {
        this.endMonth = this.dateFormat(new Date(new Date(SelectMonth.getFullYear(), SelectMonth.getMonth() + 2) - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10), 'yyyy-MM')
        // แปลงข้อมูลโดยกำหนดวันที่เริ่มต้นของเดือน และวันสุดท้ายของเดือน
        lastday = new Date(SelectMonth.getFullYear(), (SelectMonth.getMonth() + 2) + 1, 0).getDate()
        this.dateFormatted = this.dateFormat(new Date(new Date(SelectMonth.getFullYear(), SelectMonth.getMonth()) - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10), 'yyyy-MM-dd')
        this.dateFormatted2 = this.dateFormat(new Date(new Date(SelectMonth.getFullYear(), SelectMonth.getMonth() + 3) - lastday), 'yyyy-MM-dd')
      } else if (this.dataSelect === 'ราย 6 เดือน') {
        this.endSixMonth = this.dateFormat(new Date(new Date(SelectMonth.getFullYear(), SelectMonth.getMonth() + 5) - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10), 'yyyy-MM')
        // แปลงข้อมูลโดยกำหนดวันที่เริ่มต้นของเดือน และวันสุดท้ายของเดือน
        lastday = new Date(SelectMonth.getFullYear(), (SelectMonth.getMonth() + 5) + 1, 0).getDate()
        this.dateFormatted = this.dateFormat(new Date(new Date(SelectMonth.getFullYear(), SelectMonth.getMonth()) - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10), 'yyyy-MM-dd')
        this.dateFormatted2 = this.dateFormat(new Date(new Date(SelectMonth.getFullYear(), SelectMonth.getMonth() + 6) - lastday), 'yyyy-MM-dd')
        // var startTH = new Date(SelectMonth.getFullYear(), SelectMonth.getMonth()).toLocaleDateString('th-TH', { year: 'numeric', month: 'long' })
        // var endTH = new Date(SelectMonth.getFullYear(), SelectMonth.getMonth() + 5).toLocaleDateString('th-TH', { year: 'numeric', month: 'long' })
        // console.log('startTH', startTH)
        // console.log('endTH', endTH)
      }
      this.endMonth = this.dateFormat(new Date(new Date(SelectMonth.getFullYear(), SelectMonth.getMonth() + 2) - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10), 'yyyy-MM')
      this.modalStartMonth = false
      this.getData()
      this.getDataTopTen()
    }
  }
}
</script>
<style scoped>
.sales-text {
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 40px;
  color: #6497D5;
}
.sales-text-mobile {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 30px;
  color: #6497D5;
}
.sales-text-ipad {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: #6497D5;
}
.order-text {
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 40px;
  color: #2CD9C5;
}
.order-text-mobile {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 30px;
  color: #2CD9C5;
}
.order-text-ipad {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: #2CD9C5;
}
.information-text {
  font-size: 16px;
  text-align: center;
  justify-content: center;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #636363;
}
.information-text-mobile {
  font-size: 16px;
  text-align: center;
  justify-content: center;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 30px;
  color: #636363;
}
.information-text-ipad {
  font-size: 16px;
  text-align: center;
  justify-content: center;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 30px;
  color: #636363;
}
</style>
